import { CloudinaryContext } from 'cloudinary-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import i18n from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <I18nextProvider i18n={i18n}>
        <CloudinaryContext cloudName="dxlhv2mji">
          <App />
        </CloudinaryContext>
      </I18nextProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Only report web vitals in production
if (process.env.NODE_ENV === 'production') {
  reportWebVitals((metric) => {
    const body = JSON.stringify(metric);
    fetch('/api/vitals', {
      body,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
    });
  });
}
